export default __webpack_public_path__ + "static/kpatel-2eb08b8ac6b356b27e6858bf914cba31.jpeg";